// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__28f0L","container":"Modal_container__8voy-","body":"Modal_body__VPrJY","closeButton":"Modal_closeButton__3YiwX"};